import React from 'react';
import { graphql, type HeadProps } from 'gatsby';
import { StoryblokComponent } from 'gatsby-source-storyblok';
import SEO from '../components/Storyblok/SEO';
import { useStoryblokSSG } from '../hooks';
import { PageData, PageSEO } from '../types';

type NewsletterPageProps = {
  data: PageData;
};

const Newsletter = ({ data = {} }: NewsletterPageProps) => {
  const { storyToRender } = useStoryblokSSG(data.storyblokEntry ?? null, { slug: 'newsletter' });

  return <div className="h-full">{storyToRender?.content && <StoryblokComponent blok={storyToRender.content} />}</div>;
};

export default Newsletter;

export const query = graphql`
  query NewsletterPageQuery {
    storyblokEntry(slug: { eq: "newsletter" }) {
      id
      internalId
      content
      name
      full_slug
    }
  }
`;

export function Head({ location, data = {} }: HeadProps<PageData>) {
  if (!data.storyblokEntry) return null;

  const content = JSON.parse(data.storyblokEntry.content) as PageSEO;
  const metaData = {
    title: content.metaDataTitle,
    description: content.metaDataDescription,
    image: content.metaDataImage?.filename,
    imageTwitter: content.metaDataImageTwitter?.filename,
    imageAltText: content?.metaDataImageAltText,
    location,
    fbDomainVerification: content.metaDataFbDomainVerification,
  };

  // @ts-expect-error SEO component is not typed
  return <SEO {...metaData} />;
}
